module.exports = __webpack_public_path__ + "img/row1_col1_dfs.73f8a078.svg";